import React, { useState, useEffect, useRef } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import Dropdown from "components/Dropdown";
import { useMutation } from "@apollo/client";
import { CREATE_DEVICE } from "graphql/service";
import { Head, Container, InputRow, Footer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";

const ModalAddDevice = ({
  hidden,
  buttonStyle,
  setDevices
}) => {

  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [port, setPort] = useState("");
  const [ipAddress, setIpAddress] = useState("");

  const types = [
    { label: "Payment Terminal", value: "PAYMENT_TERMINAL" },
    { label: "Card Dispenser", value: "KEYCARD_DISPENSER" },
    { label: "Passport Scanner", value: "PASSPORT_SCANNER" },
  ]

  const [createDevice, { loading }] = useMutation(CREATE_DEVICE, {
    onCompleted: (data) => {
      setIsOpen(false);
      setDevices((prevDevices) => [...prevDevices, data.createDevice]);
      setName("");
      setType("");
      setPort("");
      setIpAddress("");
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception);
        }
        debouncedErrorMessage(content);
      }
    }
  });

  const handleAddDevice = () => {
    createDevice({
      variables: {
        input: {
          name,
          type,
          port,
          ipAddress,
        },
      },
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Add New Device"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 169px;
        `}
      >
        <Head>Add Device</Head>
        <Container>
          <InputRow>
            <Input
              inputFieldRef={inputRef}
              title="DEVICE NAME"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
            <Dropdown
              title="DEVICE TYPE"
              required
              options={types}
              value={types.find((option) => option.value === type)?.label || ""}
              onChange={(e) => setType(e)}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
          </InputRow>
          <InputRow>
            <Input
              title="IP ADDRESS"
              required
              value={ipAddress}
              onChange={(e) => setIpAddress(e.target.value)}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
            <Input
              title="PORT"
              required
              value={port}
              onChange={(e) => setPort(e.target.value)}
              additionalstyle={`
                width: calc(50% - 8px);
              `}
            />
          </InputRow>
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 121px;
            `}
            onClick={handleAddDevice}
            data-loading={loading}
          >
            {loading ? null : "Add Device"}
          </Button>
        </Footer>
      </MainModal>
    </>
  );
};

export default ModalAddDevice;
